import React from 'react'
import EventListener from 'react-event-listener'

const withPropsCallback = (options, props) => {
    let propOptions = {}

    for (const [key, value] of Object.entries(options)) {
        if (typeof value == 'function') propOptions[key] = value(props)
        else propOptions[key] = value
    }

    return propOptions
}

const WithEventListener = options => WrappedComponent => props => (
    <div>
        <EventListener {...withPropsCallback(options, props)} />
        <WrappedComponent {...props} />
    </div>
)

export default WithEventListener
